import { useSelector } from 'react-redux';
import { useFeature } from '@src/globalStore/featureStore';
import { CURRENT_PRODUCT_MODE } from '@src/utils/constants';
import { PERSONAL_PRESETS_FEATURE } from '@src/utils/presets/personalPresets';
import { modeSelector } from '@src/store/trends/selectors';
import { MODE_TRENDS } from '@src/store/trends/constants';

export default function usePersonalPresetsEnabled() {
  const enabled = useFeature(PERSONAL_PRESETS_FEATURE);
  const { mode } = useSelector(modeSelector);
  return Boolean(enabled) && CURRENT_PRODUCT_MODE === 'EI' && mode === MODE_TRENDS;
}
